import React, { useEffect } from "react";
import { Heading } from "../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../design/table";
import { useEvent } from "../../contexts/EventContext";
import EventListItem from "./components/EventList/EventListIItem";
import EmptyStateView from "../../components/EmptyStateView";
import ImportButton from "../../components/ImportButton/ImportButton";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import TasksComponent from "../../components/TaskComponent/TasksComponent";
import ClientOnboardingDialog from "./components/ClientOnboardingDialog";
import EventButton from "../../components/EventButton";
import { Navbar, NavbarItem } from "../../design/navbar";
import FileListPage from "./components/FileList/FileListPage";
import EventListPage from "./components/EventList/EventListPage";
import CreateFileButton from "../../components/CreateFileButton";
import { ArrowUpIcon, FolderIcon } from "@heroicons/react/20/solid";
import CreateFolderButton from "../../components/CreateFolderButton";

const IncidentListPage: React.FC = () => {
  const { events, loading, error } = useEvent();
  const [selectedTab, setSelectedTab] = React.useState<"events" | "evidence">(
    "events",
  );

  if (loading.list) {
    return <LoadingView title="Loading Events" />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <>
      <ClientOnboardingDialog />
      <div className="flex items-end justify-between gap-4">
        <Heading>Incidents</Heading>
        {selectedTab === "events" && (
          <div className="flex items-center gap-2">
            <EventButton date={events[0]?.eventDate ?? undefined} />
            <ImportButton />
          </div>
        )}
        {selectedTab === "evidence" && (
          <div className="flex items-center gap-2">
            <CreateFileButton className="flex items-center p-6 px-4">
              <ArrowUpIcon className="mr-2" /> Upload File
            </CreateFileButton>
            <CreateFolderButton className="flex items-center px-4 py-2">
              <FolderIcon className="mr-2" /> Create folder
            </CreateFolderButton>
          </div>
        )}
      </div>
      <TasksComponent taskType="event" />
      <Navbar>
        <NavbarItem
          current={selectedTab === "events"}
          onClick={() => setSelectedTab("events")}
        >
          Events
        </NavbarItem>
        <NavbarItem
          current={selectedTab === "evidence"}
          onClick={() => setSelectedTab("evidence")}
        >
          Evidence
        </NavbarItem>
      </Navbar>
      {selectedTab === "events" && <EventListPage />}
      {selectedTab === "evidence" && <FileListPage />}
    </>
  );
};

export default IncidentListPage;
